import React from "react";
import PlatformOverview from "../../components/platform/PlatformOverview";
import PlatformPlans from "../../components/platform/PlatformPlans";
import PlatformInvoices from "../../components/platform/PlatformInvoices";
import PlatformTraining from "../../components/platform/PlatformTraining";
import { PageShell } from "./PageShell";

export function PlatformBillingPage() {
  return (
    <PageShell title="Billing Overview" testid="platform-billing-page"
      subtitle="Recurring revenue, plan mix and AI usage cost across all Lestari customers.">
      <PlatformOverview />
    </PageShell>
  );
}

export function PlatformPlansPage() {
  return (
    <PageShell title="Plans & Pricing" testid="platform-plans-page"
      subtitle="Feature catalogue, package tiers and add-on pricing for the whole platform.">
      <PlatformPlans />
    </PageShell>
  );
}

export function PlatformInvoicesPage() {
  return (
    <PageShell title="Invoices" testid="platform-invoices-page"
      subtitle="Platform invoices issued to tenants — generate, mark paid or void.">
      <PlatformInvoices />
    </PageShell>
  );
}

export function PlatformTrainingPage() {
  return (
    <PageShell title="Training Media" testid="platform-training-page"
      subtitle="Guided walkthrough recordings served to tenant Setup Centres.">
      <PlatformTraining />
    </PageShell>
  );
}
